export default "__VITE_ASSET__CCndvjqZ__"